import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '@shared/models/pagination.model';
import { SignedUrlObject } from '@shared/models/signedUrlObject.model';
import { BaseService } from '@shared/services/base.service';
import { Observable } from 'rxjs';

import {
  ReduceToClearRequestListContent,
  ReduceToClearRequestSearchCriteria,
  ReduceToClearRequestViewResponse
} from '../model/reduce-to-clear-request.model';

@Injectable({
  providedIn: 'root'
})
export class ReduceToClearRequestService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.rtcRequest;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getReduceToClearRequestList(criteria: ReduceToClearRequestSearchCriteria) {
    const params = this.getParams(criteria);
    const url = this.getFullUrlWithStoreNo(this.envService.requestList);

    return this.http.get<Pagination<ReduceToClearRequestListContent>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params
    });
  }

  getReduceToClearRequestView(docNo: string) {
    const url = this.getFullUrlWithStoreNo(this.envService.view, { docNo });

    return this.http.get<Pagination<ReduceToClearRequestViewResponse>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  override getFileUrl(refId: string): Observable<SignedUrlObject> {
    const url = this.getFullUrlWithStoreNo(this.envService.fileUrl);
    return this.http.post<SignedUrlObject>(url, { refId }, { headers: this.headers });
  }
}
